import { render, staticRenderFns } from "./Ccourseinfo.vue?vue&type=template&id=c13ef21a&"
import script from "./Ccourseinfo.vue?vue&type=script&lang=js&"
export * from "./Ccourseinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports